import { Link } from "react-router-dom";
import type { HotEvent } from "@/mocks/events";

export function formatViews(n: number): string {
  if (n >= 10000) return `${(n / 10000).toFixed(1).replace(/\.0$/, "")}万`;
  return `${n}`;
}

type EventCardProps = {
  event: HotEvent;
  large?: boolean;
};

export default function EventCard({ event, large }: EventCardProps) {
  return (
    <article className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200/70 bg-background-100 transition hover:border-primary-500/50">
      <Link to={`/event/${event.slug}`} className="relative block overflow-hidden" aria-label={event.title}>
        <div className={`relative ${large ? "aspect-[16/9]" : "aspect-[16/9]"} w-full overflow-hidden`}>
          <img
            src={event.thumb}
            alt={`${event.title}现场实拍`}
            className="h-full w-full object-cover transition duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-background-950/80 via-transparent to-transparent"></div>
          <span className="absolute left-3 top-3 flex items-center gap-1.5 rounded-full bg-accent-500 px-2.5 py-1 text-xs font-semibold text-foreground-950">
            <i className="ri-fire-line"></i>{event.categoryName}
          </span>
          <span className="absolute bottom-3 right-3 flex items-center gap-1 rounded bg-background-950/80 px-2 py-1 text-xs font-medium text-foreground-100">
            <i className="ri-time-line"></i>{event.duration}
          </span>
          <span className="absolute bottom-3 left-3 flex items-center gap-1.5 rounded bg-background-950/70 px-2 py-1 text-xs text-foreground-200">
            <i className="ri-eye-line"></i>{formatViews(event.views)}次观看
          </span>
        </div>
        <span className="absolute inset-0 m-auto flex h-12 w-12 items-center justify-center rounded-full bg-primary-500/90 text-background-50 opacity-0 transition group-hover:opacity-100">
          <i className="ri-play-fill text-xl pl-0.5"></i>
        </span>
      </Link>
      <div className="flex flex-1 flex-col p-4 md:p-5">
        <h3 className={large ? "font-heading text-lg font-bold leading-snug text-foreground-950 md:text-xl" : "font-heading text-base font-bold leading-snug text-foreground-950"}>
          <Link to={`/event/${event.slug}`} className="transition hover:text-primary-500">
            {event.title}
          </Link>
        </h3>
        <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-500">
          {event.summary}
        </p>
        <div className="mt-auto flex items-center justify-between pt-4 text-xs text-foreground-600">
          <span className="flex items-center gap-1.5 whitespace-nowrap"><i className="ri-map-pin-2-line"></i>{event.location}</span>
          <span className="whitespace-nowrap">{event.time}</span>
        </div>
      </div>
    </article>
  );
}